﻿import "@fiqas/utils"
import { FIQAssist } from "../app";
import { IResourceOf } from "../interfaces/iFqs"
import { WebLink } from "./base"

export interface CaseFileData {
    createdBy: string;
    createdOn: ISODateTimeString;
    modifiedBy: string;
    modifiedOn: ISODateTimeString;
    description: string;
    filename: string;
    content: string;
}

export interface CaseFile extends IResourceOf<CaseFileData>, CaseFileData { }